import { Button } from "@/shared/components";

type DossierActionsProps = {
    onCreateNewDossier?: () => void;
};

export function DossierActions({ onCreateNewDossier }: Readonly<DossierActionsProps>) {
    return (
        <div className="dossier-actions gap-xs flex flex-col justify-center">
            <Button
                iconOnly
                variant="secondary"
                icon="plus"
                onClick={onCreateNewDossier}
                aria-label="Maak nieuw dossier aan"
                title="Maak nieuw dossier aan"
            />
        </div>
    );
}
